




































import Vue from 'vue'
import { mapGetters } from 'vuex'
interface Reports {
    title: string
    image: string
    value: number
}
export default Vue.extend({
    name: 'ReportingItems',
    props: {
        isHomePage: {
            type: Boolean,
            default: false
        }
    },
    created() {
        // Fetches our data from the api for our report fields whenever a change occurs
        this.$store.dispatch('messagesTableGetTopRowData')
    },
    computed: {
        ...mapGetters({
            messagesTableMessagesDelivered: 'messagesTableMessagesDelivered',
            messagesTableBroadcastsSent: 'messagesTableBroadcastsSent',
            messagesTableMessagesRecieved: 'messagesTableMessagesRecieved',
            messagesTableContactsReached: 'messagesTableContactsReached'
        }),
        // Function that we loop through to show our analytics in Message Feed
        getReportValues(): Reports[] {
            const reportValues = [
                {
                    title: 'Messages Delivered',
                    image: 'bi-chat-square-dots-fill',
                    value: this.messagesTableMessagesDelivered
                },
                {
                    title: 'Broadcasts Sent',
                    image: 'bi-megaphone-fill',
                    value: this.messagesTableBroadcastsSent
                },
                {
                    title: 'Messages Received',
                    image: 'bi-inbox-fill',
                    value: this.messagesTableMessagesRecieved
                },
                {
                    title: 'Contacts Reached',
                    image: 'mdi-account-multiple',
                    value: this.messagesTableContactsReached
                }
            ]
            return reportValues
        }
    },
    methods: {
        popSendToHelpDialog(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                icon: 'mdi-help-circle',
                color: 'primary',
                title: 'Help',
                text: `Data is for activity in the last 30 days.`
            })
        }
    }
})
